import { combineReducers } from 'redux';
import createReducer from 'utils/createReducer';
import {
  OPEN_PLATFORM_LOGIN_SET_APP,
  OPEN_PLATFORM_LOGIN_SET_IS_MOKA_OPEN_API_REDIRECT,
} from './types';

const app = createReducer(
  {},
  {
    [OPEN_PLATFORM_LOGIN_SET_APP]: (draft, { payload }) => payload.app,
  }
);

const isMokaOpenApiRedirect = createReducer(false, {
  [OPEN_PLATFORM_LOGIN_SET_IS_MOKA_OPEN_API_REDIRECT]: (draft, { payload }) =>
    payload.isMokaOpenApiRedirect,
});

export default combineReducers({
  app,
  isMokaOpenApiRedirect,
});
